import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cart from "components/cart";
import SlidingPane from "react-sliding-pane";
import { closeCart, openCart } from "slices/cart";
import { useGlobalContext } from "context/global";
import { isMobile } from "utils/device-detect";
import { ReactComponent as ArrowDownIcon } from "assets/svgs/curved-down-arrow.svg";

const SlideCart = () => {
	const { isOpen, loading, totalProgress, activeBox } = useSelector((state) => state.cart);
	const { isCollection } = useGlobalContext();
	const dispatch = useDispatch();
	const isMobileView = isMobile();

	useEffect(() => {
		if (!isCollection) return;
		if (totalProgress === activeBox?.size?.value) dispatch(openCart());
	}, [totalProgress, activeBox]);

	return (
		<SlidingPane
			from={isMobileView ? "bottom" : "right"}
			shouldCloseOnEsc
			className="!w-full md:!w-[360px] !h-[90%] md:!h-full !mb-0"
			overlayClassName="z-50"
			isOpen={isOpen}
			hideHeader
			onRequestClose={() => dispatch(closeCart())}
		>
			<button
				onClick={() => dispatch(closeCart())}
				aria-label="Close cart"
				className="md:hidden fixed -top-[19px] left-1/2 -translate-x-1/2 z-[1001] !border-none"
			>
				<ArrowDownIcon />
			</button>

			<Cart loading={loading} />
		</SlidingPane>
	);
};

export default SlideCart;
